import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 18 18'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='m5.365 16.125-2.74-2.74 2.74-2.74.79.813-1.364 1.364h8.074v-3h1.125v4.125H4.791l1.365 1.364zM4.01 8.178V4.053h9.199l-1.365-1.364.79-.814 2.741 2.74-2.74 2.74-.79-.813 1.364-1.364H5.135v3z'
    />
  </svg>
)
export default SvgComponent
